export default "__VITE_ASSET__7kd6VSiB__"